import { Base } from "../core/base.model";

export class Discusion extends Base {

  id:number; 
	tipo:string;
	id_tipo:number; 
	comentario :string; 
	usuario :number; 
	fecha_registro :Date;
	nombre_usuario:string;
}
